import { createApp } from 'vue'
import App from './App.vue'
import router from '@/router'
import vuetify from '@/plugins/vuetify'
import i18n from '@/i18n'
import './app.css'

createApp(App).use(router).use(vuetify).use(i18n).mount('#app')
